<template>
    <div>
        <a @click="$router.go(-1)" class="profile-edit-close-btn">
            <img src="/assets/img/close-icon.svg"/>
        </a>
        <section class="setting-profile-popup profile-edit" id="manage-account">
            <div class="setting-profile-wrapper  text-left">
                <h1>Manage Account</h1>
                <ul class="tabs">
                    <li :class="{ current: activeTab == 'profile'}" class="tab-link pointer" data-tab="Profile">
                        <a @click="setActiveTab('profile')">Profile</a></li>
                    <li class="tab-link pointer" :class="{ current: activeTab == 'security'}" data-tab="Security"><a
                        @click="setActiveTab('security')">Security</a></li>
                    <li class="tab-link pointer" :class="{ current: activeTab == 'notifications'}" data-tab="Notifications"><a
                        @click="setActiveTab('notifications')">Notifications</a></li>
                    <li v-if="! user.free_plan && profile_loaded" class="tab-link pointer" :class="{ current: activeTab == 'subscription'}" data-tab="Subscription">
                        <a target="_blank" :href="subscription_url">Subscription</a></li>
                </ul>
                <form>
                    <div id="Profile" class="tab-content" :class="{ current: activeTab == 'profile'}">
<!--                        <div class="toast" style="display: block;" v-if="successMessage">-->
<!--                            <p><img src="/assets/img/checkbox-outline.svg" alt="">{{ successMessage }}</p>-->
<!--                        </div>-->
                        <div class="updated-message-wrapper no-sidebar mt-2" v-if="successMessage">
                            <div class="updated-message profile-flash" style="display: block;">
                                <p><img src="/assets/img/checkbox-outline.svg" alt="">{{ successMessage }}</p>
                            </div>
                        </div>

                        <div class="setting-profile-part">
                            <form>
                                <div class="profile-account">
                                    <div class="profile-photo">
                                        <div class="upload-photo-img" v-if="user.name && !user.photo" >
                                            <avatar v-bind:username="user.name" :size="avatarSize"></avatar>
                                        </div>
                                        <div class="upload-photo-img" v-if="user.photo" >
                                            <avatar v-bind:username="user.name" v-bind:src="'/storage/' + user.photo"   :size="avatarSize"></avatar>
                                        </div>
                                    </div>
                                    <div class="profile-name">
                                        <h3>{{ user.name }}</h3>
                                        <div class="add-photo btn btn-sm-primary">
                                            <input type="file" id="file" ref="file" class="form-control-file"
                                                   v-on:change="handleFileUpload()">
                                            <span v-if="user.photo">Change Photo</span>
                                            <span v-else>Add Photo</span>

                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="FullName">Full Name</label>
                                    <input type="email" class="form-control" v-model="user.name" id="FullName">
                                </div>
                                <div class="form-group">
                                    <label for="Email">Email</label>
                                    <input type="email" class="form-control" v-model="user.email" id="Email">
                                </div>
                                <div class="invalid-feedback" v-for="error in errors">
                                    {{ error[0] }}
                                </div>
                                <div class="form-btn">
                                    <button type="button" name="" class="update-button btn btn-primary">
                                        <div class="update-loader" v-if="savingStatus == 'doing'">
                                            <div class="loader-center">
                                                <span class="l-1"></span>
                                                <span class="l-2"></span>
                                                <span class="l-3"></span>
                                            </div>
                                        </div>
                                        <span class="update-button-done" v-else-if="savingStatus == 'done'"></span>
                                        <span class="update-btn-text" @click="saveProfile()" v-else>Update</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div id="Security" class="tab-content" :class="{ current: activeTab == 'security'}">
                        <div class="toast" style="display: block;" v-if="successMessage">
                            <p><img src="/assets/img/checkbox-outline.svg" alt="">{{ successMessage }}</p>
                        </div>
                        <div class="setting-profile-part">
                            <form>
                                <div class="form-group">
                                    <label for="CurrentPassword">Current Password</label>
                                    <input type="Password" v-model="passwords.old_password" class="form-control"
                                           id="CurrentPassword">
                                </div>
                                <div class="form-group">
                                    <label for="NewPassword">New Password</label>
                                    <input type="Password" v-model="passwords.password" class="form-control"
                                           id="NewPassword">
                                </div>
                                <div class="form-group">
                                    <label for="ConfirmNewPassword">Confirm New Password</label>
                                    <input type="Password" v-model="passwords.password_confirmation"
                                           class="form-control" id="ConfirmNewPassword">
                                </div>
                                <div class="invalid-feedback" v-for="error in errors">
                                    {{ error[0] }}
                                </div>
                                <div class="form-btn">
                                    <button type="button" name="" class="update-button btn btn-primary">
                                        <div class="update-loader" v-if="savingStatus == 'doing'">
                                            <div class="loader-center">
                                                <span class="l-1"></span>
                                                <span class="l-2"></span>
                                                <span class="l-3"></span>
                                            </div>
                                        </div>
                                        <span class="update-button-done" v-else-if="savingStatus == 'done'"></span>
                                        <span class="update-btn-text" @click="saveSecurity()" v-else>Update</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div id="Notifications" class="tab-content" :class="{ current: activeTab == 'notifications'}">
                        <div class="toast" style="display: block;" v-if="successMessage">
                            <p><img src="/assets/img/checkbox-outline.svg" alt="">{{ successMessage }}</p>
                        </div>
                        <div class="setting-profile-part">
                            <form>
                                <h4>Comment notifications</h4>
                                <p>Configure which notifications are sent to your inbox.</p>
                                <div class="comment-notifications-switch" v-if="user.notification_settings">
                                    <div class="form-field">
                                        <span class="switch switch-sm">
                                            <input type="checkbox" class="switch" v-model="user.notification_settings.comments"
                                                   id="commentsSwitch">
                                            <label for="commentsSwitch">Comments Notification</label>
                                        </span>
                                    </div>
                                    <div class="form-field mt-2">
                                        <span class="switch switch-sm">
                                            <input type="checkbox" class="switch" v-model="user.notification_settings.likes"
                                                   id="notificationSwitch">
                                            <label for="notificationSwitch">Likes Notification</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" v-for="error in errors">
                                    {{ error[0] }}
                                </div>
                                <div class="form-btn">
                                    <button type="button" name="" class="update-button btn btn-primary">
                                        <div class="update-loader" v-if="savingStatus == 'doing'">
                                            <div class="loader-center">
                                                <span class="l-1"></span>
                                                <span class="l-2"></span>
                                                <span class="l-3"></span>
                                            </div>
                                        </div>
                                        <span class="update-button-done" v-else-if="savingStatus == 'done'"></span>
                                        <span class="update-btn-text" @click="saveProfile()" v-else>Update</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    </div>

</template>

<script>
import ApiService from "../../api/api.service";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import Avatar from 'vue-avatar';

export default {
    name: "ProfileEdit",
    components: {
        Avatar
    },
    data: function () {
        return {
            profile_loaded : false,
            errorMessage: "",
            successMessage: "",
            text: "success",
            errors: [],
            activeTab: 'profile',
            savingStatus: '',
            user: {
                name: null,
                email: null,
                photo: null,
                notification_settings: {
                    comments: true,
                    likes: true,
                },
            },
            passwords: {
                old_password: null,
                password: null,
                password_confirmation: null,
            },

            file: '',

            avatarSize: 90,

            subscription_url: process.env.MIX_APP_CHARGEBEE_PORTAL_URL,
        };
    },
    mounted() {
        this.loadProfile();

        if(this.isMobile()) {
            this.avatarSize = 60;
        }
    },
    watch: {
        successMessage: function (oldVal, newVal) {
            console.log((oldVal, newVal));
        }
    },
    methods: {
        loadProfile: function () {
            ApiService.setHeader();
            ApiService.get('/api/user').then(({data}) => {
                this.user.name = data.name;
                this.user.email = data.email;
                this.user.photo = data.photo;
                this.user.free_plan = data.free_plan;
                if (data.notification_settings) {
                    this.user.notification_settings = JSON.parse(data.notification_settings);
                }
                this.profile_loaded = true;

            }).catch(error => {
                throw new Error('failed to load user');
            });
        },

        setActiveTab: function (tab = 'profile') {
            this.activeTab = tab;
            this.errors = [];
        },

        saveProfile() {
            this.savingStatus = 'doing';
            ApiService.setHeader();
            ApiService.post('/api/user/update', this.user).then(({data}) => {
                this.setSuccessMessage(data.message);
            }).catch(({response}) => {
                this.savingStatus = '';
                this.errors = response.data.errors;
                throw new Error('failed to save profile')
            });
        },
        saveSecurity() {
            this.savingStatus = 'doing';
            ApiService.setHeader();
            ApiService.post('/api/user/password', this.passwords).then(({data}) => {
                this.setSuccessMessage(data.message);
            }).catch(({response}) => {
                this.savingStatus = '';
                this.errors = response.data.errors;
            });
        },
        saveNotifications() {
            this.savingStatus = 'doing';
            ApiService.setHeader();
            ApiService.put('/api/user/notification_settings', this.notification).then(({data}) => {
                this.setSuccessMessage(data.message);
            }).catch(({response}) => {
                this.savingStatus = '';
                this.errors = response.data.errors;
            });
        },
        handleFileUpload() {
            this.savingStatus = 'doing';
            this.file = this.$refs.file.files[0];
            let formData = new FormData();
            formData.append('file', this.file);
            ApiService.postFile('/api/user/photo', formData).then(({data}) => {
                if (data.status) {
                    this.$nextTick(() => {
                        this.user.photo = data.path;
                    });
                    this.setSuccessMessage(data.message);
                }
            }).catch(({response}) => {
                this.savingStatus = '';
                this.errors = response.data.errors;
            });
        },

        nameInitials: function (name) {
            let initials = name.match(/\b\w/g) || [];
            return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
        },

        setSuccessMessage(message) {
            setTimeout(() => {
                this.successMessage = message;
                this.savingStatus = 'done';
                this.passwords = {
                    old_password: null,
                    password: null,
                    password_confirmation: null,
                };
                setTimeout(() => {
                    this.savingStatus = '';
                    this.successMessage = '';
                }, 2000);
            }, 2000);
            this.errors = [];
        },
        closeProfileEdit() {
            this.$parent.profilePopUp = false;
            //
            let el = document.getElementById('navbarSupportedContent');
            el.classList.remove("show");
        },

        isMobile: function() {
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        }


    },

}
</script>

<style scoped>
    .tabs li:not(.current) a {
        color: #000;
    }
</style>
